import { useSettingsStore } from '@supsupclub/ui-components';

import { TCDE } from './tc-de';
import { TCEN } from './tc-en';
import { TCNL } from './tc-nl';
import { TCPT } from './tc-pt';

const TC_MAP: Record<string, () => React.JSX.Element> = {
  de: TCDE,
  en: TCEN,
  nl: TCNL,
  pt: TCPT,
};

export const TC = () => {
  const locale = useSettingsStore((store) => store.locale);
  const Component = TC_MAP[locale] ?? TCNL;
  return <Component />;
};
